// Added by Sejune Oh on 2019-02-07
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react'
import Button, { ButtonProps } from '@material-ui/core/Button'
import styled from 'styled-components'
import { GREY_COLOR, RED_COLOR } from '@/styles/Theme'
import { ReactClickEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Properties of button component
 */
interface ButtonFCProps extends ButtonProps {
    btnText: string
    onClick?: ReactClickEvent
    buttonType?: 'default' | 'task' | 'danger'
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const ButtonElement: FC<ButtonFCProps> = ({
    variant = 'contained',
    buttonType = 'default',
    btnText,
    ...other
}) => {
    if (buttonType === 'task') {
        return (
            <TaskButton variant={variant} {...other}>
                {btnText}
            </TaskButton>
        )
    }

    if (buttonType === 'danger') {
        return (
            <DangerButton variant={variant} {...other}>
                {btnText}
            </DangerButton>
        )
    }

    return (
        <DefaultButton variant={variant} {...other}>
            {btnText}
        </DefaultButton>
    )
}

const TaskButton = styled(Button as FC<any>)`
    && {
        background-color: ${(props) => (props.disabled ? 'rgba(255, 255, 255, 0.12)' : '#145c82')};
        border: 1px solid #437c9b;
        border-color: ${(props) => (props.disabled ? '#676767' : '#437c9b')};
        color: ${(props) => (props.disabled ? 'rgba(255, 255, 255, 0.3)' : '#fff')};

        &:hover {
            background-color: #0e405b;
        }
    }
`
const DangerButton = styled(Button as FC<any>)`
    && {
        background-color: ${(props) => (props.disabled ? 'rgba(255, 255, 255, 0.12)' : RED_COLOR)};
        background-color: ${RED_COLOR};
        border: 1px solid #ff2c2c;
        border-color: ${(props) => (props.disabled ? '#676767' : '#ff2c2c')};
        color: ${(props) => (props.disabled ? 'rgba(255, 255, 255, 0.3)' : '#fff')};

        &:hover {
            background-color: #7b1010;
        }
    }
`
const DefaultButton = styled(Button as FC<any>)`
    && {
        background-color: ${GREY_COLOR};
        border: 1px solid #676767;
        color: ${(props) => (props.disabled ? 'rgba(255, 255, 255, 0.3)' : '#fff')};

        &:hover {
            background-color: #2e2e2e;
        }
    }
`

export default ButtonElement
